<template>
        <div id="homeInfo">
           
                <div class="top">
                  <div class="status-card" :class="getTishiClass()">
                    <div class="status-left">
                      <div class="status-dot"></div>
                      <div class="status-info">
                         <div class="status-label">当前状态</div>
                         <div class="status-value">{{ getStatus() }}</div>
                      </div>
                    </div>
                    <div class="status-desc">{{tishicontent}}</div>
                    <div class="status-action" v-if="storestastus==1||storestastus==0">
                      <a v-if="storestastus==1" href="javascript:void(0)" class="action-btn action-start" @click="openCloseStore(1)">开始营业</a>
                      <a v-if="storestastus==0" href="javascript:void(0)" class="action-btn action-stop" @click="openCloseStore(2)">暂停营业</a>
                    </div>
                  </div>
                </div>
                
                <div class="content">
                    <div class="storeinfo">
                        <div class="chart_title">酒店统计</div>
                        <!-- 商家收益 -->
                        <div class="revenue_section">
                            <div class="section_title">商家收益</div>
                            <div class="revenue_top">
                                <div class="available_box">
                                    <div class="available_label">可结算金额(元)</div>
                                    <div class="available_amount">¥{{ fenToYuan(revenue.availableAmount) }}</div>
                                    <div class="total_tip">账户总收益：¥{{ fenToYuan(revenue.totalRevenue) }}</div>
                                </div>
                                <a href="javascript:void(0);" class="settle_btn">结算</a>
                            </div>
                            <div class="revenue_chart" ref="revenueChart"></div>
                        </div>
                        <div class="chart_box">
                            <div class="chart_item">
                                <div class="chart_item_title">今日订单统计</div>
                                <div class="chart_content" ref="todayChart"></div>
                            </div>
                            <div class="chart_item">
                                <div class="chart_item_title">当月订单统计</div>
                                <div class="chart_content" ref="monthChart"></div>
                            </div>
                        </div>
                    </div>
                    <!-- 商家交易明细 -->
                    <div class="storeinfo">
                        <div class="chart_title">
                            <span>商家交易明细</span>
                            <a href="javascript:void(0)" class="detail-link" @click="goTransactionDetail">查看全部 &raquo;</a>
                        </div>
                        <div class="nobook_chart" ref="nobookChart"></div>
                    </div>
                </div>
          
        </div>
  
</template>

<script>
import * as echarts from 'echarts';
import { selectStoreInfo, selectOrderStatistics, updateStoreStatus, selectStoreRevenue, selectAcctNobook } from '@/tools/Api';
import { ElMessage, ElMessageBox } from 'element-plus';


export default {
  name: 'news',
  data(){
    return {
        storeId:"",//酒店id
        tishicontent:"正在获取酒店信息，请稍候...",
        storestastus:-1,//酒店状态
        orderStatistics:{//订单统计
            todayNewOrders:0,//今日新增订单数
            todayPendingOrders:0,//今日待确认订单数
            todayCompletedOrders:0,//今日已完成订单数
            todayRefundOrders:0,//今日退款订单数
            monthNewOrders:0,//当月新增订单数
            monthPendingOrders:0,//当月待确认订单数
            monthCompletedOrders:0,//当月已完成订单数
            monthRefundOrders:0,//当月退款订单数
        },
        revenue:{//商家收益
            availableAmount:0,//可结算金额(分)
            pendingAmount:0,//待结算金额(分)
            totalRevenue:0,//总收益(分)
        },
        nobookList:[],//最近三天交易明细
     
    }
  },
  methods: {
    getTishiClass(){
      if(this.storestastus==3||this.storestastus==4||this.storestastus==0){
        return 'tishi_green'
      }else if(this.storestastus==5){ 
        return 'tishi_red'
      }else if(this.storestastus==2){ 
        return 'tishi_yellow'
      }else if(this.storestastus==1){ 
        return 'tishi_gray'
      }
    },
    getStatus(){
      switch(this.storestastus) {
        case 0: return '营业中';
        case 1: return '暂停营业中';
        case 2: return '整改中'; 
        case 3: return '待审核';
        case 4: return '审核中';
        case 5: return '审核拒绝';
      }
    },
    getTishiContent(){
      switch(this.storestastus) {
        case 0: return '当前酒店正在营业中，请关注订单情况，如果需要暂停营业，请点击暂停营业按钮停止营业。';
        case 1: return '当前酒店处于暂停营业状态，客人暂时无法预订您的房间，如需恢复营业，请点击开始营业按钮。';
        case 2: return '酒店正在整改中，整改完成并通过平台审核后将恢复营业，如有疑问请联系平台客服。';
        case 3: return '酒店信息已提交，等待平台审核，请耐心等待。审核通过后即可正常营业。';
        case 4: return '酒店信息正在审核中，请耐心等待审核结果，审核期间部分功能可能受限。';
        case 5: return '很抱歉，您的酒店信息审核未通过，请前往酒店信息管理页面修改信息后重新提交审核。';
        default: return '';
      }
    },
    //查询酒店信息
    getStoreInfo(){
      selectStoreInfo().then(res=>{
        if(res.status==0){
          const data=res.data
          this.storeId=data.storeId
          this.storestastus=data.storeStatus
          this.tishicontent=this.getTishiContent()
        }else{
          ElMessage({
            message:res.msg||"获取酒店信息失败",
            type:'error',
            duration:1500
          })
        }
      }).catch(error=>{
        ElMessage({
          message:"请求失败！",
          type:'error',
          duration:1500
        })
      })
    },
    //查询酒店订单统计
    getOrderStatistics(){
      selectOrderStatistics().then(res=>{
        if(res.status==0){
          this.orderStatistics=res.data||{}
          this.initCharts()
        }else{
          ElMessage({
            message:res.msg||"获取订单统计失败",
            type:'error',
            duration:1500
          })
        }
      }).catch(error=>{
        ElMessage({
          message:"请求失败！",
          type:'error',
          duration:1500
        })
      })
    },
    //初始化柱状图
    initCharts(){
      this.initTodayChart()
      this.initMonthChart()
    },
    //柱状图公共配置
    getBarChartOption(categories,values){
      //与页面状态色风格保持一致
      const colors=['#e57834','#f0ad4e','#41924e','#d9534f']
      return {
        tooltip:{
          trigger:'axis',
          axisPointer:{type:'shadow'}
        },
        grid:{
          left:'3%',
          right:'4%',
          bottom:'3%',
          top:30,
          containLabel:true
        },
        xAxis:{
          type:'category',
          data:categories,
          axisTick:{
            alignWithLabel:true
          }
        },
        yAxis:{
          type:'value',
          minInterval:1//订单数为整数，坐标轴不留小数
        },
        series:[{
          name:'订单数',
          type:'bar',
          barWidth:'40%',
          data:values.map((value,index)=>{
            return {
              value:value,
              itemStyle:{
                color:colors[index%colors.length]
              }
            }
          })
        }]
      }
    },
    //今日订单统计柱状图
    initTodayChart(){
      if(!this.$refs.todayChart){
        return
      }
      if(!this.todayChart){
        this.todayChart=echarts.init(this.$refs.todayChart)
      }
      this.todayChart.setOption(this.getBarChartOption(
        ['新增订单','待确认订单','已完成订单','退款订单'],
        [
          this.orderStatistics.todayNewOrders||0,
          this.orderStatistics.todayPendingOrders||0,
          this.orderStatistics.todayCompletedOrders||0,
          this.orderStatistics.todayRefundOrders||0
        ]
      ))
    },
    //当月订单统计柱状图
    initMonthChart(){
      if(!this.$refs.monthChart){
        return
      }
      if(!this.monthChart){
        this.monthChart=echarts.init(this.$refs.monthChart)
      }
      this.monthChart.setOption(this.getBarChartOption(
        ['新增订单','待确认订单','已完成订单','退款订单'],
        [
          this.orderStatistics.monthNewOrders||0,
          this.orderStatistics.monthPendingOrders||0,
          this.orderStatistics.monthCompletedOrders||0,
          this.orderStatistics.monthRefundOrders||0
        ]
      ))
    },
    //金额分转元,保留两位小数并加千分位
    fenToYuan(fen){
      return ((fen||0)/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',')
    },
    //查询商家收益
    getRevenue(){
      selectStoreRevenue().then(res=>{
        if(res.status==0){
          this.revenue=res.data||{}
          this.initRevenueChart()
        }else{
          ElMessage({
            message:res.msg||"获取商家收益失败",
            type:'error',
            duration:1500
          })
        }
      }).catch(error=>{
        ElMessage({
          message:"请求失败！",
          type:'error',
          duration:1500
        })
      })
    },
    //扇形图展示可结算/待结算金额
    initRevenueChart(){
      if(!this.$refs.revenueChart){
        return
      }
      if(!this.revenueChart){
        this.revenueChart=echarts.init(this.$refs.revenueChart)
      }
      this.revenueChart.setOption({
        title:{
          text:'总收益(元)',
          subtext:'¥'+this.fenToYuan(this.revenue.totalRevenue),
          left:'center',
          top:'36%',
          textStyle:{
            fontSize:13,
            color:'#999',
            fontWeight:'normal'
          },
          subtextStyle:{
            fontSize:20,
            color:'#333',
            fontWeight:'bold'
          }
        },
        tooltip:{
          trigger:'item',
          formatter:'{b}<br/>金额：¥{c} ({d}%)'
        },
        legend:{
          bottom:0
        },
        series:[{
          name:'商家收益',
          type:'pie',
          radius:['40%','65%'],
          center:['50%','45%'],
          label:{
            formatter:'{b}: ¥{c}'
          },
          data:[
            {name:'可结算金额',value:Number(((this.revenue.availableAmount||0)/100).toFixed(2)),itemStyle:{color:'#41924e'}},
            {name:'待结算金额',value:Number(((this.revenue.pendingAmount||0)/100).toFixed(2)),itemStyle:{color:'#f0ad4e'}}
          ]
        }]
      })
    },
    //查询商家交易明细
    getAcctNobook(){
      selectAcctNobook({
        pageNum:1,
        pageSize:100
      }).then(res=>{
        if(res.status==0){
          const data=res.data||{}
          const list=data.list||[]
          //只保留最近三个交易日的记录
          this.nobookList=this.filterRecentThreeDays(list)
          this.initNobookChart()
        }else{
          ElMessage({
            message:res.msg||"获取交易明细失败",
            type:'error',
            duration:1500
          })
        }
      }).catch(error=>{
        ElMessage({
          message:"请求失败！",
          type:'error',
          duration:1500
        })
      })
    },
    //筛选最近三个交易日的明细,并按日期时间正序排列
    filterRecentThreeDays(list){
      if(!list||list.length==0){
        return []
      }
      //提取不重复交易日期,降序(最新在前)取前三个
      const dateMap={}
      list.forEach(item=>{
        dateMap[item.txnDate]=true
      })
      const dates=Object.keys(dateMap).map(Number).sort((a,b)=>b-a)
      const recentDates=dates.slice(0,3)
      return list.filter(item=>recentDates.indexOf(item.txnDate)>-1).sort((a,b)=>{
        if(a.txnDate!=b.txnDate){
          return a.txnDate-b.txnDate
        }
        return (''+a.creatTime).localeCompare(''+b.creatTime)
      })
    },
    //格式化明细时间标签  如"2026-08-26 10:30:00"->"08-26 10:30"
    formatNobookTime(item){
      const time=''+(item.creatTime||'')
      if(time.length>=16){
        return time.substring(5,16)
      }
      const date=''+(item.txnDate||'')
      if(date.length==8){
        return date.substring(4,6)+'-'+date.substring(6,8)
      }
      return date
    },
    //折线图展示最近三天交易明细  C-贷(收入)为正 D-借(支出)为负
    initNobookChart(){
      if(!this.$refs.nobookChart){
        return
      }
      if(!this.nobookChart){
        this.nobookChart=echarts.init(this.$refs.nobookChart)
      }
      const xData=this.nobookList.map(item=>this.formatNobookTime(item))
      const yData=this.nobookList.map(item=>{
        const amt=Number(((item.amt||0)/100).toFixed(2))
        return item.dcFlag=='C'?amt:-amt
      })
      this.nobookChart.setOption({
        tooltip:{
          trigger:'axis',
          formatter:(params)=>{
            const p=params[0]
            const item=this.nobookList[p.dataIndex]
            if(!item){
              return ''
            }
            const amt=(item.amt||0)/100
            const flag=item.dcFlag=='C'?'+':'-'
            let html=p.name+'<br/>金额：'+flag+amt.toFixed(2)+'元'
            if(item.remark){
              html+='<br/>'+item.remark
            }
            return html
          }
        },
        grid:{
          left:'3%',
          right:'4%',
          bottom:'3%',
          top:30,
          containLabel:true
        },
        xAxis:{
          type:'category',
          data:xData,
          axisLabel:{
            rotate:30
          }
        },
        yAxis:{
          type:'value',
          name:'金额(元)'
        },
        series:[{
          name:'交易金额',
          type:'line',
          data:yData,
          symbol:'circle',
          symbolSize:8,
          label:{
            show:true,
            fontSize:11,
            formatter:(p)=>{
              return p.value>0?'+'+p.value.toFixed(2):p.value.toFixed(2)
            }
          },
          lineStyle:{color:'#e57834'},
          itemStyle:{color:'#e57834'}
        }]
      })
    },
    //窗口缩放时图表自适应
    resizeCharts(){
      if(this.todayChart){
        this.todayChart.resize()
      }
      if(this.monthChart){
        this.monthChart.resize()
      }
      if(this.revenueChart){
        this.revenueChart.resize()
      }
      if(this.nobookChart){
        this.nobookChart.resize()
      }
    },
    //跳转交易明细页
    goTransactionDetail(){
      this.$router.push({name:"transactiondetail"});
    },
    //开始营业/暂停营业  op:1开始营业 2暂停营业
    openCloseStore(op){
      const status=op==1?0:1
      ElMessageBox.confirm('该酒店将进行'+(op==1?'开始营业':'暂停营业')+'操作, 是否继续?','提示',{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        type:'warning'
      }).then(()=>{
        updateStoreStatus({
          storeStatus:status
        }).then(res=>{
          if(res.status==0){
            ElMessage({
              message:(op==1?'开始营业':'暂停营业')+"成功！",
              type:'success',
              duration:1500
            })
            this.getStoreInfo()
          }else{
            ElMessage({
              message:res.msg||"操作失败",
              type:'error',
              duration:1500
            })
          }
        }).catch(error=>{
          ElMessage({
            message:"请求失败！",
            type:'error',
            duration:1500
          })
        })
      }).catch(()=>{
        ElMessage({
          type:'info',
          message:'已取消操作'
        })
      })
    }
  },
  mounted() {
    this.getStoreInfo()
    this.getOrderStatistics()
    this.getRevenue()
    this.getAcctNobook()
    window.addEventListener('resize', this.resizeCharts)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeCharts)
    if(this.todayChart){
      this.todayChart.dispose()
      this.todayChart=null
    }
    if(this.monthChart){
      this.monthChart.dispose()
      this.monthChart=null
    }
    if(this.revenueChart){
      this.revenueChart.dispose()
      this.revenueChart=null
    }
    if(this.nobookChart){
      this.nobookChart.dispose()
      this.nobookChart=null
    }
  }
}
</script>
<style scoped>
#homeInfo{
  width: 100%;
  height: 100%;
  position: relative;
  overflow-y: auto;
  padding: 24px 32px;
  background: #f5f6f8;
}
/* 状态卡片 */
#homeInfo .top{
  width: 100%;
}
#homeInfo .top .status-card{
  width: 100%;
  border-radius: 12px;
  padding: 24px 30px;
  display: flex;
  align-items: center;
  gap: 24px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  transition: all 0.3s;
}
/* 状态颜色主题 */
#homeInfo .top .status-card.tishi_green{
  background: linear-gradient(135deg, #e8f5e9, #f1f8e9);
  border-left: 4px solid #41924e;
}
#homeInfo .top .status-card.tishi_green .status-dot{
  background: #41924e;
  box-shadow: 0 0 8px rgba(65,146,78,0.5);
}
#homeInfo .top .status-card.tishi_green .status-value{
  color: #41924e;
}
#homeInfo .top .status-card.tishi_red{
  background: linear-gradient(135deg, #fce4ec, #fff3f0);
  border-left: 4px solid #d9534f;
}
#homeInfo .top .status-card.tishi_red .status-dot{
  background: #d9534f;
  box-shadow: 0 0 8px rgba(217,83,79,0.5);
}
#homeInfo .top .status-card.tishi_red .status-value{
  color: #d9534f;
}
#homeInfo .top .status-card.tishi_yellow{
  background: linear-gradient(135deg, #fff8e1, #fffde7);
  border-left: 4px solid #f0ad4e;
}
#homeInfo .top .status-card.tishi_yellow .status-dot{
  background: #f0ad4e;
  box-shadow: 0 0 8px rgba(240,173,78,0.5);
}
#homeInfo .top .status-card.tishi_yellow .status-value{
  color: #f0ad4e;
}
#homeInfo .top .status-card.tishi_gray{
  background: linear-gradient(135deg, #f5f5f5, #fafafa);
  border-left: 4px solid #999;
}
#homeInfo .top .status-card.tishi_gray .status-dot{
  background: #999;
  box-shadow: 0 0 8px rgba(153,153,153,0.4);
}
#homeInfo .top .status-card.tishi_gray .status-value{
  color: #999;
}
/* 左侧状态区 */
.status-left{
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}
.status-dot{
  width: 14px;
  height: 14px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}
@keyframes pulse{
  0%,100%{ opacity:1; }
  50%{ opacity:0.5; }
}
.status-info{
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.status-label{
  font-size: 12px;
  color: #999;
}
.status-value{
  font-size: 20px;
  font-weight: 700;
}
/* 描述文字 */
.status-desc{
  flex: 1;
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  border-left: 1px solid rgba(0,0,0,0.08);
  padding-left: 24px;
}
/* 操作按钮 */
.status-action{
  flex-shrink: 0;
}
.action-btn{
  display: inline-block;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  color: #fff;
  transition: all 0.3s;
}
.action-start{
  background: linear-gradient(135deg, #41924e, #4caf50);
  box-shadow: 0 4px 12px rgba(65,146,78,0.3);
}
.action-start:hover{
  box-shadow: 0 6px 16px rgba(65,146,78,0.4);
  transform: translateY(-1px);
}
.action-stop{
  background: linear-gradient(135deg, #d9534f, #e57373);
  box-shadow: 0 4px 12px rgba(217,83,79,0.3);
}
.action-stop:hover{
  box-shadow: 0 6px 16px rgba(217,83,79,0.4);
  transform: translateY(-1px);
}

/* 内容区卡片 */
#homeInfo .content{
  width: 100%;
  margin-top: 20px;
}
#homeInfo .content .storeinfo{
  background: #fff;
  border-radius: 12px;
  margin-bottom: 20px;
  padding: 24px 28px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  border: none;
}
#homeInfo .content .storeinfo .chart_title{
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#homeInfo .content .storeinfo .chart_title .detail-link{
  font-size: 13px;
  font-weight: 500;
  color: #12ab04d4;
  text-decoration: none;
  transition: color 0.2s;
}
#homeInfo .content .storeinfo .chart_title .detail-link:hover{
  color: #0d8a03;
}
#homeInfo .content .storeinfo .chart_box{
  width: 100%;
  display: flex;
  gap: 24px;
}
#homeInfo .content .storeinfo .chart_box .chart_item{
  flex: 1;
  min-width: 0;
}
#homeInfo .content .storeinfo .chart_box .chart_item:last-child{
  margin-left: 0;
}
#homeInfo .content .storeinfo .chart_box .chart_item .chart_item_title{
  font-size: 14px;
  font-weight: 600;
  color: #555;
  text-align: center;
  margin-bottom: 8px;
}
#homeInfo .content .storeinfo .chart_box .chart_item .chart_content{
  width: 100%;
  height: 280px;
}

/* 商家收益 */
#homeInfo .content .storeinfo .revenue_section{
  margin-bottom: 20px;
}
#homeInfo .content .storeinfo .revenue_section .section_title{
  font-size: 15px;
  font-weight: 600;
  color: #555;
  margin-bottom: 16px;
}
#homeInfo .content .storeinfo .revenue_top{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
#homeInfo .content .storeinfo .revenue_top .available_box{
  flex: 1;
}
#homeInfo .content .storeinfo .revenue_top .available_label{
  font-size: 13px;
  color: #999;
  margin-bottom: 4px;
}
#homeInfo .content .storeinfo .revenue_top .available_amount{
  font-size: 34px;
  font-weight: 800;
  color: #e57834;
  line-height: 1.2;
  margin-bottom: 4px;
}
#homeInfo .content .storeinfo .revenue_top .total_tip{
  font-size: 13px;
  color: #888;
}
#homeInfo .content .storeinfo .revenue_top .settle_btn{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 42px;
  background: linear-gradient(135deg, #41924e, #4caf50);
  color: #fff;
  border-radius: 8px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(65,146,78,0.25);
  transition: all 0.3s;
}
#homeInfo .content .storeinfo .revenue_top .settle_btn:hover{
  box-shadow: 0 6px 16px rgba(65,146,78,0.35);
  transform: translateY(-1px);
}
#homeInfo .content .storeinfo .revenue_chart{
  width: 100%;
  height: 280px;
}

/* 交易明细 */
#homeInfo .content .storeinfo .nobook_tip{
  font-size: 13px;
  font-weight: normal;
  color: #bbb;
  margin-left: 10px;
}
#homeInfo .content .storeinfo .nobook_chart{
  width: 100%;
  height: 280px;
  margin-top: 12px;
}
</style>